import React from "react";

import { DerbyEventStatus } from "@fdr/types/ts/Derby";
import DerbyPicks from "@fdr/atomic-ui/_organisms/DerbyPicks";
import HeaderBanner from "@urp/derby-banner";
import { HomeHeaderProps } from "../../types";
import { Container } from "./styled-components";

const HomeHeader = ({
  raceStartDate,
  eventStatus,
  showDerbyPicks,
  derbyPicks,
  isNumberFire,
  onBannerCtaClick,
  baseBet,
  bannerCfg
}: HomeHeaderProps) =>
  bannerCfg ? (
    <Container data-qa-label="derby-header">
      <HeaderBanner
        raceStartDate={raceStartDate}
        eventStatus={eventStatus}
        bannerCfg={bannerCfg}
        onCtaClick={onBannerCtaClick}
      />

      {eventStatus === DerbyEventStatus.DERBY_DAY && showDerbyPicks && (
        <DerbyPicks
          picks={derbyPicks}
          isNumberFire={isNumberFire}
          baseBet={baseBet}
        />
      )}
    </Container>
  ) : null;

export default HomeHeader;
